/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiTransactionRelatedPersonType {
    INDIVIDUAL = 'INDIVIDUAL',
    PRIVATE = 'PRIVATE',
    BUSINESS = 'BUSINESS',
    LEGAL = 'LEGAL',
    UNDEFINED = 'UNDEFINED'
}


export function instanceOfInternalApiTransactionRelatedPersonType(value: any): boolean {
    for (const key in InternalApiTransactionRelatedPersonType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiTransactionRelatedPersonType, key)) {
            if (InternalApiTransactionRelatedPersonType[key as keyof typeof InternalApiTransactionRelatedPersonType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiTransactionRelatedPersonTypeFromJSON(json: any): InternalApiTransactionRelatedPersonType {
    return InternalApiTransactionRelatedPersonTypeFromJSONTyped(json, false);
}

export function InternalApiTransactionRelatedPersonTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransactionRelatedPersonType {
    return json as InternalApiTransactionRelatedPersonType;
}

export function InternalApiTransactionRelatedPersonTypeToJSON(value?: InternalApiTransactionRelatedPersonType | null): any {
    return value as any;
}

export function InternalApiTransactionRelatedPersonTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiTransactionRelatedPersonType {
    return value as InternalApiTransactionRelatedPersonType;
}

